export default __webpack_public_path__ + "static/media/snapkick.c012b54c.png";